module.exports = __webpack_public_path__ + "img/loading.bad57362.gif";